<script setup lang="ts">
import { useTemplateRef } from "vue";
import type { QrCodeProps } from "./qrcode.types";
import { qrCodeClasses } from "./qrcode.styles";
import { useQrCode } from "./useQrCode";

const props = withDefaults(defineProps<QrCodeProps>(), {
  type: "canvas",
  width: 200,
  scale: 4,
  margin: 4,
  errorCorrectionLevel: "M",
});

const canvasRef = useTemplateRef<HTMLCanvasElement>("canvasRef");
const svgContainerRef = useTemplateRef<HTMLElement>("svgContainerRef");
useQrCode({ props, canvasRef, svgContainerRef });
</script>

<template>
  <div :class="qrCodeClasses({ type })" part="base">
    <canvas v-if="type !== 'svg'" ref="canvasRef" />
    <div v-else ref="svgContainerRef" />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
